import BaseModelAPI from '../BaseModelAPI';

export default class FinishGoodQualityInspectNgInbox extends BaseModelAPI {
	static entity = 'finishgoodqualityinspectnginbox';
	static entityName = 'finishgoodqualityinspectnginbox';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.problemCategoryId = '';
			this.problemCategory = {};
			this.qtyNg = 0;
			this.finishGoodQualityInspectInboxId = '';
			this.finishGoodQualityInspectInbox = {};
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}